import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setFlightSelected} from '@Redux/search/Flight/action';
const UseTempData = (depend: any[]) => {
    const [tempSelectData, setSelectTempData] = useState(); //回上一步則返回一開始的篩選值
    // const [tempCardData, setTempCardData] = useState(); //回上一步則返回一開始的篩選值

    // const { TagList } = useSelector((state: RootState) => state.search.reducer);
    // const { GroupFilterSelected } = useSelector((state: RootState) => state.search.GroupReducer);
    // const { HotelFilterSelected } = useSelector((state: RootState) => state.search.HotelReducer);
    // const { TicketFilterSelected } = useSelector((state: RootState) => state.search.TicketReducer);
    // const { VocationFilterSelected } = useSelector(
    //     (state: RootState) => state.search.VocationReducer
    // );
    // const { AllFilterSelected } = useSelector((state: RootState) => state.search.AllReducer);

    // function tagListSwitch() {
    //     let dispatchStore: any = undefined;
    //     let selectedState: any = undefined;
    //     switch (
    //         TagList // 清除篩選條件 不更新排序、產品類型(SortType)
    //     ) {
    //         case 'grp':
    //             selectedState = GroupFilterSelected;
    //             dispatchStore = setGroupSelected;
    //             break;
    //         case 'vac':
    //             selectedState = VocationFilterSelected;
    //             dispatchStore = setVocationSelected;

    //             break;
    //         case 'htl':
    //             selectedState = HotelFilterSelected;
    //             dispatchStore = setHotelSelected;

    //             break;
    //         case 'etk':
    //             selectedState = TicketFilterSelected;
    //             dispatchStore = setTicketSelected;

    //             break;
    //         default:
    //             selectedState = AllFilterSelected;
    //             dispatchStore = setAllSelected;
    //     }
    //     return [selectedState, dispatchStore];
    // }
    const [selectedState] = tagListSwitch();
    useEffect(() => {
        // if (!isSlideOpen) return; // 關閉的時候不存下selected 紀錄
        setSelectTempData(selectedState);
    }, [...depend]);

    return [tempSelectData, ...tagListSwitch()];
};
export default UseTempData;

function tagListSwitch() {
    const { TagList } = useSelector((state: RootState) => state.search.reducer);
    const { GroupFilterSelected } = useSelector((state: RootState) => state.search.GroupReducer);
    const { HotelFilterSelected } = useSelector((state: RootState) => state.search.HotelReducer);
    const { TicketFilterSelected } = useSelector((state: RootState) => state.search.TicketReducer);
    const { VocationFilterSelected } = useSelector(
        (state: RootState) => state.search.VocationReducer
    );
    const { FlightFilterSelected } = useSelector((state: RootState) => state.search.FlightReducer);
    const { AllFilterSelected } = useSelector((state: RootState) => state.search.AllReducer);
    let dispatchStore: any = undefined;
    let selectedState: any = undefined;
    switch (
        TagList // 清除篩選條件 不更新排序、產品類型(SortType)
    ) {
        case 'grp':
            selectedState = GroupFilterSelected;
            dispatchStore = setGroupSelected;
            break;
        case 'vac':
            selectedState = VocationFilterSelected;
            dispatchStore = setVocationSelected;

            break;
        case 'htl':
            selectedState = HotelFilterSelected;
            dispatchStore = setHotelSelected;

            break;
        case 'etk':
            selectedState = TicketFilterSelected;
            dispatchStore = setTicketSelected;

            break;
        case 'flt':
            selectedState = FlightFilterSelected;
            dispatchStore = setFlightSelected;

            break;
        default:
            selectedState = AllFilterSelected;
            dispatchStore = setAllSelected;
    }
    return [selectedState, dispatchStore];
}
